// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1CzeH","description":"styles_description__1-F3w","content":"styles_content__3Y_DC","divider":"styles_divider__J0n1s"};